var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"mask"}},[(_vm.show)?_c('div',{staticClass:"s-modal-mask",on:{"click":function($event){return _vm.$emit('update:show', false)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }